import { useId } from "react";

type CustomCheckboxProps = {
  label: string;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  name?: string;
  labelClass?: string;
  wrapperClass?: string;
};
const CustomCheckbox: React.FC<CustomCheckboxProps> = ({
  label,
  checked = false,
  onChange,
  name,
  labelClass = "",
  wrapperClass = "",
}) => {
  // useId hook generates a unique ID for accessibility (linking label to input)
  const id = useId();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    onChange?.(checked); // Call parent's onChange if provided
  };

  return (
    <>
      <label
        htmlFor={id}
        className={`checkbox-label flex items-center gap-3 cursor-pointer ${wrapperClass}`}
      >
        <input
          type="checkbox"
          id={id}
          name={name}
          className="hidden-checkbox"
          checked={checked}
          onChange={handleChange}
        />
        <span className="custom-checkbox"></span>
        <span
          className={`text-primary-text text-subtitle-4 font-regular ${labelClass}`}
        >
          {label}
        </span>
      </label>
    </>
  );
};
export default CustomCheckbox;
